var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useComptroller } from '~src/providers/ContractProvider';
import { Zero } from '~src/utils/constants';
export const useGetAccountLiquidity = () => {
    const comptroller = useComptroller();
    return useCallback((address) => __awaiter(void 0, void 0, void 0, function* () {
        if (!comptroller) {
            return {
                liquidity: Zero,
                shortfall: Zero,
            };
        }
        const [error, liquidity, shortfall] = (yield comptroller.getAccountLiquidity(address));
        if (error.eq(0)) {
            return {
                liquidity,
                shortfall,
            };
        }
        return {
            liquidity: Zero,
            shortfall: Zero,
        };
    }), [comptroller]);
};
